<button #openorgselect style="display: none;"  data-toggle="modal" data-target="#showorgselect"></button>
  <!-- Modal -->

  <div class="modal fade" id="showorgselect" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgswitcher.header' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="mb-0 text-muted">{{ 'orgswitcher.subhead' | trans }}</p>
            <ul class="org-list-ul">
                    <li *ngFor="let org of orglist" class="org-list-li pr-1 pt-1 pb-1 font-weight-light" (click)="orgClicked(org)"> {{org.organization}}</li>
            </ul>
        </div>
      </div>
    </div>
  </div>